import {money} from "./money";
import {mandatory} from "./mandatory";

export function selfUsedPropertyValidation(field, {livingConditions}) {

    if (livingConditions === 'PROPERTY_OWNERSHIP') {
        return mandatory(field);
    }

    return undefined;
}

export function monthlyRateLeaseValidation(field, {selfUsedProperty, livingConditions}) {

    if ((livingConditions === 'PROPERTY_OWNERSHIP' && selfUsedProperty === 'no') || livingConditions === 'RENT') {
        return mandatory(field) || money(field);
    }

    return undefined;
}

export function monthlyRatePropertyValidation(field, fields) {

    if (fields.livingConditions === 'PROPERTY_OWNERSHIP') {
        return mandatory(field) || money(field);
    }

    return undefined;
}


export function monthlyAlimonyFieldValidation(field, {otherObligationAlignment}) {

    if (otherObligationAlignment === 'yes') {
        return mandatory(field) || money(field)
    }

    return undefined;
}

export function monthlyFeeInsuranceValidation(field, {insuranceType}) {

    if (insuranceType === 'private') {
        return mandatory(field) || money(field);
    }

    return undefined;
}
